import { MembershipInfoResponse } from 'services/member/queries/useMembershipInfo/useMembershipInfo.interface';
import collectiveApi from 'modules/common/collectiveApi';

export default async function fetchMembershipInfo() {
    const { data } = await collectiveApi.get<MembershipInfoResponse>('/membershipinfo/');
    return data;
}
